import { insertIntoNode, unmountComponentAtNode } from 'reactApp';

export default function (app) {
  app.directive('reactComponent', [
    '$state',
    '$rootScope',
    'klAccountService',
    ($state, $rootScope, AccountService) => {
      return {
        restrict: 'A',
        scope: {
          path: '@',
          params: '=',
          data: '=',
        },
        link: function link(scope, element) {
          const node = element[0];
          const { path, data } = scope;
          const params = $state.params;
          const updateScope = (fn) => fn(scope);
          insertIntoNode(
            { path, data, params, updateScope, $state, $rootScope, AccountService },
            node,
          );

          element.on('$destroy', function () {
            unmountComponentAtNode(node);
          });
        },
        template: '<div></div>',
      };
    },
  ]);
}
